import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import Hero from './components/Hero';
import AboutUs from './components/AboutUs';
import SectionImage from './components/SectionImage';
import Services from './components/Services';
import SectionImage2 from './components/SectionImage2';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ApplyPage from './components/ApplyPage';
import 'aos/dist/aos.css';
import AOS from 'aos';
import './custom.css';

function App() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true, offset: 60 });
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <AboutUs />
              <SectionImage />
              <Services />
              <SectionImage2 />
              <Contact />
              <Footer />
            </>
          }
        />
        <Route
          path="/apply"
          element={
            <>
              <ApplyPage />
              <Footer />
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
